

// // import { 
// //   FiGlobe, FiUsers, FiTrendingUp, FiAward, 
// //   FiBookOpen 
// // } from "react-icons/fi";
// // import { FaHandshake } from "react-icons/fa";
// // import { GiWorld } from "react-icons/gi";

// // const keyFunctions = [
// //   { icon: <GiWorld />, title: "Mission Networking", desc: "Coordinate with Indian Missions, Commercial Offices abroad, and Foreign Missions in India." },
// //   { icon: <FiUsers />, title: "Delegations & Trade Missions", desc: "Organise inbound and outbound Heads of State visits, business delegations, and trade missions." },
// //   { icon: <FaHandshake />, title: "B2B & B2G Meetings", desc: "Facilitate stakeholder meetings and enable participation in trade fairs and investment forums." },
// //   { icon: <FiBookOpen />, title: "Knowledge Events", desc: "Organise conferences, seminars, and business round-tables on trade and investment." },
// //   { icon: <FiAward />, title: "MoUs & Partnerships", desc: "Forge strategic institutional partnerships and MoUs with international chambers." },
// //   { icon: <FiTrendingUp />, title: "Policy Advocacy", desc: "Undertake public policy advocacy through representations with regulators and decision-makers." },
// //   { icon: <FiGlobe />, title: "Market Access", desc: "Support government on trade policy, investment barriers, and market access negotiations." },
// //   { icon: <FiAward />, title: "MDA & MAI Programs", desc: "Support Department of Commerce's MDA and MAI programmes for export growth." },
// //   { icon: <FiBookOpen />, title: "Market Intelligence", desc: "Disseminate global business, trade, and investment intelligence across networks." },
// //   { icon: <FaHandshake />, title: "Certificates of Origin", desc: "Issue Certificates of Origin (Non-Preferential) for goods exported from India." },
// //   { icon: <FiUsers />, title: "Visa Recommendations", desc: "Issue visa recommendation letters to facilitate overseas business visits." },
// // ];

// // const councils = [
// //   { title: "Export & Trade", color: "from-[#DA2128] to-[#DB2628]" },
// //   { title: "Exports & Trade", color: "from-[#DB6400] to-[#F59C00]" },
// //   { title: "Business through Diplomacy", color: "from-[#DA2128] to-[#DB2628]" },
// //   { title: "Africa Business Council", color: "from-[#DB6400] to-[#F59C00]" },
// //   { title: "BIMSTEC", color: "from-[#DA2128] to-[#DB2628]" },
// //   { title: "Eurasia", color: "from-[#DB6400] to-[#F59C00]" },
// //   { title: "BRICS SME Forum", color: "from-[#DA2128] to-[#DB2628]" },
// //   { title: "Indo American Business Forum", color: "from-[#DB6400] to-[#F59C00]" },
// // ];

// // export default function Overview() {
// //   return (
// //     <section id="overview" className="scroll-mt-20 max-w-7xl mx-auto space-y-8 px-4 sm:px-6">
      
// //       {/* Top Banner - Hero Paragraph 1 */}
// //       <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#DB2628] to-[#DA2128] px-6 py-8 md:px-10 md:py-10 shadow-xl shadow-[#DA2128]/15 text-white">
// //         <div className="absolute -right-16 -top-16 h-64 w-64 rounded-full bg-white/10 blur-3xl pointer-events-none" />
// //         <div className="relative z-10 max-w-4xl space-y-3">
// //           <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3.5 py-1 text-xs font-semibold text-white backdrop-blur-md border border-white/20">
// //             <FiGlobe className="h-3.5 w-3.5" /> International Division
// //           </div>
// //           <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-semibold tracking-tight leading-tight">
// //             Council <span className="italic font-normal">Overview</span>
// //           </h2>
// //           <p className="text-xs md:text-sm text-white/95 leading-relaxed font-light">
// //             ASSOCHAM has established a strong global presence by partnering with industries, governments, business associations, and strategic stakeholders worldwide, reinforcing its role as India's Apex Chamber of Commerce.
// //           </p>
// //         </div>
// //       </div>

// //       {/* Main Content Grid - Front-End Policy Forum & Economic Diplomacy Cards */}
// //       <div className="grid gap-6 md:grid-cols-2">
        
// //         {/* Paragraph 2: Front-End Policy Forum */}
// //         <div className="rounded-3xl bg-[#FAF7F2] p-6 shadow-sm border border-[#FEF7F4] relative overflow-hidden group hover:-translate-y-0.5 transition-all duration-300 flex flex-col justify-between">
// //           <div className="absolute top-0 right-0 h-28 w-28 bg-gradient-to-bl from-[#DA2128]/10 to-transparent rounded-full -mr-8 -mt-8 pointer-events-none" />
// //           <div>
// //             <div className="flex items-center gap-3 mb-3">
// //               <div className="h-10 w-10 rounded-xl bg-[#DA2128] text-white flex items-center justify-center shadow-md shadow-[#DA2128]/20 shrink-0">
// //                 <FiUsers className="h-5 w-5" />
// //               </div>
// //               <h3 className="text-xl font-semibold text-[#1a1a2e] font-['Outfit']">Front-End Policy Forum</h3>
// //             </div>
// //             <p className="text-xs md:text-sm text-[#4a4a5a] leading-relaxed">
// //               The International Affairs Division serves as ASSOCHAM's front-end Industry Policy Forum for global engagement. The Division promotes business competitiveness, provides industry insights and market intelligence, fosters public policy dialogue, and facilitates global trade, foreign investment, and international collaborations that create new opportunities for industry members.
// //             </p>
// //           </div>
// //         </div>

// //         {/* Paragraph 3: Economic Diplomacy */}
// //         <div className="rounded-3xl bg-[#FAF7F2] p-6 shadow-sm border border-[#FEF7F4] relative overflow-hidden group hover:-translate-y-0.5 transition-all duration-300 flex flex-col justify-between">
// //           <div className="absolute top-0 right-0 h-28 w-28 bg-gradient-to-bl from-[#DB6400]/10 to-transparent rounded-full -mr-8 -mt-8 pointer-events-none" />
// //           <div>
// //             <div className="flex items-center gap-3 mb-3">
// //               <div className="h-10 w-10 rounded-xl bg-[#DB6400] text-white flex items-center justify-center shadow-md shadow-[#DB6400]/20 shrink-0">
// //                 <FiTrendingUp className="h-5 w-5" />
// //               </div>
// //               <h3 className="text-xl font-semibold text-[#1a1a2e] font-['Outfit']">Economic Diplomacy</h3>
// //             </div>
// //             <p className="text-xs md:text-sm text-[#4a4a5a] leading-relaxed">
// //               The Division also complements and supports the Government of India's agenda on economic diplomacy and development partnerships by promoting policy advocacy, facilitating foreign direct investment (FDI), strengthening bilateral and multilateral trade relations, and supporting industrial development. Through strategic partnerships with international organisations, foreign governments, and industry bodies, the Division contributes to expanding investment opportunities and strengthening India's global economic engagement.
// //             </p>
// //           </div>
// //         </div>

// //       </div>

// //       {/* Paragraph 4: Commitment & Global Impact Bar */}
// //       <div className="rounded-2xl bg-[#FAF7F2] p-5 border-l-4 border-[#DA2128] shadow-xs">
// //         <p className="text-xs md:text-sm text-[#4a4a5a] leading-relaxed">
// //           Committed to helping its members enhance efficiency, competitiveness, and international business opportunities, ASSOCHAM offers a wide range of specialised services supported by an extensive network of global partnerships and Memoranda of Understanding (MoUs) with leading chambers of commerce and industry associations worldwide. Through these initiatives, ASSOCHAM continues to connect Indian industry with global markets, fostering long-term economic cooperation and sustainable growth.
// //         </p>
// //       </div>

// //       {/* Key Functioning - Compact Grid */}
// //       <div className="rounded-3xl bg-white border border-[#FEF7F4] shadow-md shadow-black/[0.02] overflow-hidden">
// //         <div className="bg-[#FAF7F2] px-6 py-4 border-b border-[#FEF7F4]">
// //           <h3 className="text-2xl font-semibold text-[#1a1a2e] font-['Cormorant_Garamond']">Key Functioning</h3>
// //         </div>
// //         <div className="p-6">
// //           <div className="grid gap-3.5 sm:grid-cols-2 lg:grid-cols-3">
// //             {keyFunctions.map((item, i) => (
// //               <div key={i} className="flex gap-3 rounded-xl bg-[#FAF7F2] p-3.5 border border-[#FEF7F4] hover:border-[#DA2128]/30 transition-all duration-200 group">
// //                 <div className="shrink-0 h-9 w-9 rounded-lg bg-[#DA2128]/10 text-[#DA2128] flex items-center justify-center text-base group-hover:bg-[#DA2128] group-hover:text-white transition-colors duration-200">
// //                   {item.icon}
// //                 </div>
// //                 <div>
// //                   <h4 className="font-semibold text-[#1a1a2e] text-xs md:text-sm mb-0.5">{item.title}</h4>
// //                   <p className="text-[11px] md:text-xs text-[#6a6a7a] leading-snug">{item.desc}</p>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </div>

// //       {/* International Councils - Original Card Grid Layout */}
// //       <div>
// //         <div className="flex items-center gap-4 mb-8">
// //           <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#DA2128]/30 to-transparent" />
// //           <h3 className="font-['Cormorant_Garamond'] text-4xl font-semibold text-[#1a1a2e] tracking-tight text-center">
// //             International Councils <span className="italic font-normal text-[#DA2128]">& Forums</span>
// //           </h3>
// //           <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#DA2128]/30 to-transparent" />
// //         </div>
// //         <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
// //           {councils.map((c, i) => (
// //             <a key={i} href="#" className={`group relative rounded-2xl bg-gradient-to-br ${c.color} px-7 py-8 text-white shadow-xl shadow-black/10 overflow-hidden hover:scale-[1.03] transition-transform duration-300`}>
// //               <div className="absolute top-0 right-0 h-28 w-28 bg-white/10 rounded-full -mr-10 -mt-10 blur-2xl" />
// //               <h4 className="relative z-10 text-xl font-semibold font-['Outfit'] mb-3 group-hover:translate-x-1 transition-transform">{c.title}</h4>
// //               <div className="relative z-10 flex items-center gap-2 text-sm text-white/80 font-medium group-hover:text-white transition-colors">
// //                 <span>Explore</span>
// //                 <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
// //               </div>
// //             </a>
// //           ))}
// //         </div>
// //       </div>

// //     </section>
// //   );
// // }




// // new code 



// import { 
//   FiGlobe, FiUsers, FiTrendingUp, FiAward, 
//   FiBookOpen, FiArrowRight 
// } from "react-icons/fi";
// import { FaHandshake, FaGlobeAmericas, FaGlobeAfrica, FaChartLine, FaBuilding } from "react-icons/fa";
// import { GiWorld } from "react-icons/gi";

// const keyFunctions = [
//   { icon: <GiWorld />, title: "Mission Networking", desc: "Coordinate with Indian Missions, Commercial Offices abroad, and Foreign Missions in India." },
//   { icon: <FiUsers />, title: "Delegations & Trade Missions", desc: "Organise inbound and outbound Heads of State visits, business delegations, and trade missions." },
//   { icon: <FaHandshake />, title: "B2B & B2G Meetings", desc: "Facilitate stakeholder meetings and enable participation in trade fairs and investment forums." },
//   { icon: <FiBookOpen />, title: "Knowledge Events", desc: "Organise conferences, seminars, and business round-tables on trade and investment." },
//   { icon: <FiAward />, title: "MoUs & Partnerships", desc: "Forge strategic institutional partnerships and MoUs with international chambers." },
//   { icon: <FiTrendingUp />, title: "Policy Advocacy", desc: "Undertake public policy advocacy through representations with regulators and decision-makers." },
//   { icon: <FiGlobe />, title: "Market Access", desc: "Support government on trade policy, investment barriers, and market access negotiations." },
//   { icon: <FiAward />, title: "MDA & MAI Programs", desc: "Support Department of Commerce's MDA and MAI programmes for export growth." },
//   { icon: <FiBookOpen />, title: "Market Intelligence", desc: "Disseminate global business, trade, and investment intelligence across networks." },
//   { icon: <FaHandshake />, title: "Certificates of Origin", desc: "Issue Certificates of Origin (Non-Preferential) for goods exported from India." },
//   { icon: <FiUsers />, title: "Visa Recommendations", desc: "Issue visa recommendation letters to facilitate overseas business visits." },
// ];

// const councils = [
//   { 
//     title: "Export & Trade", 
//     icon: <FiTrendingUp className="w-4 h-4 text-[#DA2128]" />,
//     points: ["Trade platforms & global partnerships", "Tariff & export policy advocacy"] 
//   },
//   { 
//     title: "Business Diplomacy", 
//     icon: <FaGlobeAmericas className="w-4 h-4 text-[#DB6400]" />,
//     points: ["Diplomatic roundtables & mission networks", "Global economic engagement"] 
//   },
//   { 
//     title: "Africa Business Council", 
//     icon: <FaGlobeAfrica className="w-4 h-4 text-[#DA2128]" />,
//     points: ["B2B linkages in emerging markets", "Regional economic collaborations"] 
//   },
//   { 
//     title: "BIMSTEC Forum", 
//     icon: <GiWorld className="w-4 h-4 text-[#DB6400]" />,
//     points: ["Bay of Bengal trade corridors", "Regional MSME acceleration"] 
//   },
//   { 
//     title: "Eurasia Council", 
//     icon: <FaBuilding className="w-4 h-4 text-[#DA2128]" />,
//     points: ["CIS & East European market access", "Sector-specific trade missions"] 
//   },
//   { 
//     title: "BRICS SME Forum", 
//     icon: <FaChartLine className="w-4 h-4 text-[#DB6400]" />,
//     points: ["Global supply chain integration", "Technology transfer & joint ventures"] 
//   },
//   { 
//     title: "Indo-American Forum", 
//     icon: <FiGlobe className="w-4 h-4 text-[#DA2128]" />,
//     points: ["Bilateral investment growth", "North America tech & trade ties"] 
//   }
// ];

// export default function Overview() {
//   return (
//     <section id="overview" className="scroll-mt-20 max-w-7xl mx-auto space-y-12 px-4 sm:px-6 py-10">
      
//       {/* Top Banner - Hero Paragraph 1 */}
//  <div className="relative overflow-hidden rounded-3xl bg-slate-50 border border-slate-200/80 px-6 py-8 md:px-10 md:py-10 shadow-sm text-slate-800">
//   {/* Soft Subtle Accent Glows (No Red Block) */}
//   <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-red-500/5 blur-3xl pointer-events-none" />
  
//   <div className="relative z-10 max-w-4xl space-y-4">
//     {/* Clean Badge with Red Text & Icon */}
//     <div className="inline-flex items-center gap-2 rounded-full bg-red-50 px-3.5 py-1 text-xs font-semibold text-[#DA2128] border border-red-200/60 shadow-xs">
//       <FiGlobe className="h-3.5 w-3.5" /> International Division
//     </div>

//     {/* Elegant Heading */}
//     <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-semibold tracking-tight leading-tight text-slate-900">
//       Council <span className="italic font-normal text-[#DA2128]">Overview</span>
//     </h2>

//     {/* Highly Readable Dark Text */}
//     <p className="text-sm md:text-base text-slate-600 leading-relaxed font-normal">
//       ASSOCHAM has established a strong global presence by partnering with industries, governments, business associations, and strategic stakeholders worldwide, reinforcing its role as India's Apex Chamber of Commerce.
//     </p>
//   </div>
// </div>
//       {/* Main Content Grid */}
//       <div className="grid gap-6 md:grid-cols-2">
//         <div className="rounded-3xl bg-[#FAF7F2] p-6 shadow-sm border border-[#FEF7F4] relative overflow-hidden group hover:-translate-y-0.5 transition-all duration-300 flex flex-col justify-between">
//           <div className="absolute top-0 right-0 h-28 w-28 bg-gradient-to-bl from-[#DA2128]/10 to-transparent rounded-full -mr-8 -mt-8 pointer-events-none" />
//           <div>
//             <div className="flex items-center gap-3 mb-3">
//               <div className="h-10 w-10 rounded-xl bg-[#DA2128] text-white flex items-center justify-center shadow-md shadow-[#DA2128]/20 shrink-0">
//                 <FiUsers className="h-5 w-5" />
//               </div>
//               <h3 className="text-xl font-semibold text-[#1a1a2e] font-['Outfit']">Front-End Policy Forum</h3>
//             </div>
//             <p className="text-xs md:text-sm text-[#4a4a5a] leading-relaxed">
//               The International Affairs Division serves as ASSOCHAM's front-end Industry Policy Forum for global engagement. The Division promotes business competitiveness, provides industry insights and market intelligence, fosters public policy dialogue, and facilitates global trade, foreign investment, and international collaborations that create new opportunities for industry members.
//             </p>
//           </div>
//         </div>

//         <div className="rounded-3xl bg-[#FAF7F2] p-6 shadow-sm border border-[#FEF7F4] relative overflow-hidden group hover:-translate-y-0.5 transition-all duration-300 flex flex-col justify-between">
//           <div className="absolute top-0 right-0 h-28 w-28 bg-gradient-to-bl from-[#DB6400]/10 to-transparent rounded-full -mr-8 -mt-8 pointer-events-none" />
//           <div>
//             <div className="flex items-center gap-3 mb-3">
//               <div className="h-10 w-10 rounded-xl bg-[#DB6400] text-white flex items-center justify-center shadow-md shadow-[#DB6400]/20 shrink-0">
//                 <FiTrendingUp className="h-5 w-5" />
//               </div>
//               <h3 className="text-xl font-semibold text-[#1a1a2e] font-['Outfit']">Economic Diplomacy</h3>
//             </div>
//             <p className="text-xs md:text-sm text-[#4a4a5a] leading-relaxed">
//               The Division also complements and supports the Government of India's agenda on economic diplomacy and development partnerships by promoting policy advocacy, facilitating foreign direct investment (FDI), strengthening bilateral and multilateral trade relations, and supporting industrial development.
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Commitment Bar */}
//       <div className="rounded-2xl bg-[#FAF7F2] p-5 border-l-4 border-[#DA2128] shadow-xs">
//         <p className="text-xs md:text-sm text-[#4a4a5a] leading-relaxed">
//           Committed to helping its members enhance efficiency, competitiveness, and international business opportunities, ASSOCHAM offers a wide range of specialised services supported by an extensive network of global partnerships worldwide.
//         </p>
//       </div>

//       {/* Key Functioning Grid */}
//       <div className="rounded-3xl bg-white border border-[#FEF7F4] shadow-md shadow-black/[0.02] overflow-hidden">
//         <div className="bg-[#FAF7F2] px-6 py-4 border-b border-[#FEF7F4]">
//           <h3 className="text-2xl font-semibold text-[#1a1a2e] font-['Cormorant_Garamond']">Key Functioning</h3>
//         </div>
//         <div className="p-6">
//           <div className="grid gap-3.5 sm:grid-cols-2 lg:grid-cols-3">
//             {keyFunctions.map((item, i) => (
//               <div key={i} className="flex gap-3 rounded-xl bg-[#FAF7F2] p-3.5 border border-[#FEF7F4] hover:border-[#DA2128]/30 transition-all duration-200 group">
//                 <div className="shrink-0 h-9 w-9 rounded-lg bg-[#DA2128]/10 text-[#DA2128] flex items-center justify-center text-base group-hover:bg-[#DA2128] group-hover:text-white transition-colors duration-200">
//                   {item.icon}
//                 </div>
//                 <div>
//                   <h4 className="font-semibold text-[#1a1a2e] text-xs md:text-sm mb-0.5">{item.title}</h4>
//                   <p className="text-[11px] md:text-xs text-[#6a6a7a] leading-snug">{item.desc}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* CENTER-ALIGNED 3-COLUMN AESTHETIC CARDS */}
//       <div>
//         <div className="flex items-center gap-4 mb-8">
//           <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#DA2128]/30 to-transparent" />
//           <h3 className="font-['Cormorant_Garamond'] text-3xl md:text-4xl font-semibold text-[#1a1a2e] tracking-tight text-center">
//             International Councils <span className="italic font-normal text-[#DA2128]">& Forums</span>
//           </h3>
//           <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#DA2128]/30 to-transparent" />
//         </div>

//         {/* Flex Wrapper for perfect Centering of all 3-column rows */}
//         <div className="flex flex-wrap justify-center gap-6">
//           {councils.map((c, i) => (
//             <a 
//               key={i}
//               href="#"
//               className="group relative w-full sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] max-w-sm rounded-2xl bg-white border border-[#F3E8DF] p-5 shadow-xs hover:shadow-lg hover:shadow-[#DA2128]/5 transition-all duration-300 flex flex-col justify-between overflow-hidden hover:-translate-y-1.5"
//               style={{
//                 clipPath: 'polygon(0 0, 70% 0, 84% 12px, 100% 12px, 100% 100%, 0 100%)'
//               }}
//             >
//               {/* Soft Gradient Overlay */}
//               <div className="absolute inset-0 bg-gradient-to-br from-[#FFFDFB] via-transparent to-[#FAF5F0] opacity-80 pointer-events-none" />

//               {/* Decorative Subtle Dots */}
//               <div className="absolute bottom-2 right-2 grid grid-cols-4 gap-1 opacity-20 pointer-events-none">
//                 {[...Array(8)].map((_, idx) => (
//                   <span key={idx} className="w-1 h-1 rounded-full bg-[#DA2128]" />
//                 ))}
//               </div>

//               <div className="relative z-10">
//                 {/* Header: Icon + Title */}
//                 <div className="flex items-start gap-3 mb-3">
//                   <div className="w-9 h-9 rounded-xl bg-[#FAF1EA] border border-[#F5E2D5] flex items-center justify-center shrink-0 group-hover:scale-105 group-hover:bg-[#DA2128]/10 transition-all duration-300">
//                     {c.icon}
//                   </div>
//                   <div>
//                     <h4 className="text-base font-bold text-[#1a1a2e] font-['Outfit'] leading-tight">
//                       {c.title}
//                     </h4>
//                     {/* Accent Underline */}
//                     <div className="w-8 h-0.5 bg-gradient-to-r from-[#DA2128] to-[#FF8A65] rounded-full mt-1.5 group-hover:w-14 transition-all duration-300" />
//                   </div>
//                 </div>

//                 {/* Point-wise Bullet List */}
//                 <ul className="space-y-2 mb-4 pl-0.5">
//                   {c.points.map((pt, idx) => (
//                     <li key={idx} className="flex items-start gap-2 text-[12px] text-[#5a5a6a] leading-relaxed">
//                       <span className="w-1.5 h-1.5 rounded-full bg-[#DB6400] mt-1.5 shrink-0 shadow-2xs shadow-[#DB6400]" />
//                       <span>{pt}</span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>

//               {/* Footer CTA */}
//               <div className="relative z-10 pt-3 border-t border-[#F5ECE5] flex items-center justify-between text-xs font-semibold text-[#DA2128]">
//                 <span>Explore</span>
//                 <FiArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
//               </div>
//             </a>
//           ))}
//         </div>
//       </div>

//     </section>
//   );
// }




// new new code 



import { 
  FiGlobe, FiUsers, FiTrendingUp, FiAward, 
  FiBookOpen, FiArrowRight 
} from "react-icons/fi";
import { FaHandshake, FaGlobeAmericas, FaGlobeAfrica, FaChartLine, FaBuilding } from "react-icons/fa";
import { GiWorld } from "react-icons/gi";

const keyFunctions = [
  { icon: <GiWorld />, title: "Mission Networking", desc: "Coordinate with Indian Missions, Commercial Offices abroad, and Foreign Missions in India." },
  { icon: <FiUsers />, title: "Delegations & Trade Missions", desc: "Organise inbound and outbound Heads of State visits, business delegations, and trade missions." },
  { icon: <FaHandshake />, title: "B2B & B2G Meetings", desc: "Facilitate stakeholder meetings and enable participation in trade fairs and investment forums." },
  { icon: <FiBookOpen />, title: "Knowledge Events", desc: "Organise conferences, seminars, and business round-tables on trade and investment." },
  { icon: <FiAward />, title: "MoUs & Partnerships", desc: "Forge strategic institutional partnerships and MoUs with international chambers." },
  { icon: <FiTrendingUp />, title: "Policy Advocacy", desc: "Undertake public policy advocacy through representations with regulators and decision-makers." },
  { icon: <FiGlobe />, title: "Market Access", desc: "Support government on trade policy, investment barriers, and market access negotiations." },
  { icon: <FiAward />, title: "MDA & MAI Programs", desc: "Support Department of Commerce's MDA and MAI programmes for export growth." },
  { icon: <FiBookOpen />, title: "Market Intelligence", desc: "Disseminate global business, trade, and investment intelligence across networks." },
  { icon: <FaHandshake />, title: "Certificates of Origin", desc: "Issue Certificates of Origin (Non-Preferential) for goods exported from India." },
  { icon: <FiUsers />, title: "Visa Recommendations", desc: "Issue visa recommendation letters to facilitate overseas business visits." },
];

const councils = [
  { 
    title: "Export & Trade", 
    icon: <FiTrendingUp className="w-4 h-4 text-[#DA2128]" />,
    points: ["Trade platforms & global partnerships", "Tariff & export policy advocacy"] 
  },
  { 
    title: "Business Diplomacy", 
    icon: <FaGlobeAmericas className="w-4 h-4 text-[#DB6400]" />,
    points: ["Diplomatic roundtables & mission networks", "Global economic engagement"] 
  },
  { 
    title: "Africa Business Council", 
    icon: <FaGlobeAfrica className="w-4 h-4 text-[#DA2128]" />,
    points: ["B2B linkages in emerging markets", "Regional economic collaborations"] 
  },
  { 
    title: "BIMSTEC Forum", 
    icon: <GiWorld className="w-4 h-4 text-[#DB6400]" />,
    points: ["Bay of Bengal trade corridors", "Regional MSME acceleration"] 
  },
  { 
    title: "Eurasia Council", 
    icon: <FaBuilding className="w-4 h-4 text-[#DA2128]" />,
    points: ["CIS & East European market access", "Sector-specific trade missions"] 
  },
  { 
    title: "BRICS SME Forum", 
    icon: <FaChartLine className="w-4 h-4 text-[#DB6400]" />,
    points: ["Global supply chain integration", "Technology transfer & joint ventures"] 
  },
  { 
    title: "Indo-American Forum", 
    icon: <FiGlobe className="w-4 h-4 text-[#DA2128]" />,
    points: ["Bilateral investment growth", "North America tech & trade ties"] 
  }
];

export default function Overview() {
  return (
    <section id="overview" className="scroll-mt-20 max-w-7xl mx-auto space-y-12 px-4 sm:px-6 py-10">

      {/* Unified Overview Section - complete narrative kept together in one card */}
      <div className="relative overflow-hidden rounded-3xl bg-slate-50 border border-slate-200/80 px-6 py-8 md:px-10 md:py-10 shadow-sm text-slate-800">
        {/* Soft Subtle Accent Glows (No Red Block) */}
        <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-red-500/5 blur-3xl pointer-events-none" />
        <div className="absolute -left-20 -bottom-20 h-64 w-64 rounded-full bg-orange-500/5 blur-3xl pointer-events-none" />

        <div className="relative z-10 max-w-4xl space-y-4">
          {/* Clean Badge with Red Text & Icon */}
          <div className="inline-flex items-center gap-2 rounded-full bg-red-50 px-3.5 py-1 text-xs font-semibold text-[#DA2128] border border-red-200/60 shadow-xs">
            <FiGlobe className="h-3.5 w-3.5" /> International Division
          </div>

          {/* Elegant Heading */}
          <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-semibold tracking-tight leading-tight text-slate-900">
            Council <span className="italic font-normal text-[#DA2128]">Overview</span>
          </h2>

          {/* Complete overview copy, kept together as one flowing narrative */}
          <div className="space-y-4 text-sm md:text-base text-slate-600 leading-relaxed font-normal">
            <p>
              ASSOCHAM has established a strong global presence by partnering with industries, governments, business associations, and strategic stakeholders worldwide, reinforcing its role as India's Apex Chamber of Commerce.
            </p>
            <p>
              The International Affairs Division serves as ASSOCHAM's front-end Industry Policy Forum for global engagement. The Division promotes business competitiveness, provides industry insights and market intelligence, fosters public policy dialogue, and facilitates global trade, foreign investment, and international collaborations that create new opportunities for industry members.
            </p>
            <p>
              The Division also complements and supports the Government of India's agenda on economic diplomacy and development partnerships by promoting policy advocacy, facilitating foreign direct investment (FDI), strengthening bilateral and multilateral trade relations, and supporting industrial development. Through strategic partnerships with international organisations, foreign governments, and industry bodies, the Division contributes to expanding investment opportunities and strengthening India's global economic engagement.
            </p>
            <p className="pl-4 border-l-4 border-[#DA2128]">
              Committed to helping its members enhance efficiency, competitiveness, and international business opportunities, ASSOCHAM offers a wide range of specialised services supported by an extensive network of global partnerships and Memoranda of Understanding (MoUs) with leading chambers of commerce and industry associations worldwide. Through these initiatives, ASSOCHAM continues to connect Indian industry with global markets, fostering long-term economic cooperation and sustainable growth.
            </p>
          </div>
        </div>
      </div>

      {/* Key Functioning Grid */}
      <div className="rounded-3xl bg-white border border-[#FEF7F4] shadow-md shadow-black/[0.02] overflow-hidden">
        <div className="bg-[#FAF7F2] px-6 py-4 border-b border-[#FEF7F4]">
          <h3 className="text-2xl font-semibold text-[#1a1a2e] font-['Cormorant_Garamond']">Key Functioning</h3>
        </div>
        <div className="p-6">
          <div className="grid gap-3.5 sm:grid-cols-2 lg:grid-cols-3">
            {keyFunctions.map((item, i) => (
              <div key={i} className="flex gap-3 rounded-xl bg-[#FAF7F2] p-3.5 border border-[#FEF7F4] hover:border-[#DA2128]/30 transition-all duration-200 group">
                <div className="shrink-0 h-9 w-9 rounded-lg bg-[#DA2128]/10 text-[#DA2128] flex items-center justify-center text-base group-hover:bg-[#DA2128] group-hover:text-white transition-colors duration-200">
                  {item.icon}
                </div>
                <div>
                  <h4 className="font-semibold text-[#1a1a2e] text-xs md:text-sm mb-0.5">{item.title}</h4>
                  <p className="text-[11px] md:text-xs text-[#6a6a7a] leading-snug">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CENTER-ALIGNED 3-COLUMN AESTHETIC CARDS */}
      <div>
        <div className="flex items-center gap-4 mb-8">
          <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#DA2128]/30 to-transparent" />
          <h3 className="font-['Cormorant_Garamond'] text-3xl md:text-4xl font-semibold text-[#1a1a2e] tracking-tight text-center">
            International Councils <span className="italic font-normal text-[#DA2128]">& Forums</span>
          </h3>
          <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#DA2128]/30 to-transparent" />
        </div>

        {/* Flex Wrapper for perfect Centering of all 3-column rows */}
        <div className="flex flex-wrap justify-center gap-6">
          {councils.map((c, i) => (
            <a 
              key={i}
              href="#"
              className="group relative w-full sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] max-w-sm rounded-2xl bg-white border border-[#F3E8DF] p-5 shadow-xs hover:shadow-lg hover:shadow-[#DA2128]/5 transition-all duration-300 flex flex-col justify-between overflow-hidden hover:-translate-y-1.5"
              style={{
                clipPath: 'polygon(0 0, 70% 0, 84% 12px, 100% 12px, 100% 100%, 0 100%)'
              }}
            >
              {/* Soft Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#FFFDFB] via-transparent to-[#FAF5F0] opacity-80 pointer-events-none" />

              {/* Decorative Subtle Dots */}
              <div className="absolute bottom-2 right-2 grid grid-cols-4 gap-1 opacity-20 pointer-events-none">
                {[...Array(8)].map((_, idx) => (
                  <span key={idx} className="w-1 h-1 rounded-full bg-[#DA2128]" />
                ))}
              </div>

              <div className="relative z-10">
                {/* Header: Icon + Title */}
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-9 h-9 rounded-xl bg-[#FAF1EA] border border-[#F5E2D5] flex items-center justify-center shrink-0 group-hover:scale-105 group-hover:bg-[#DA2128]/10 transition-all duration-300">
                    {c.icon}
                  </div>
                  <div>
                    <h4 className="text-base font-bold text-[#1a1a2e] font-['Outfit'] leading-tight">
                      {c.title}
                    </h4>
                    {/* Accent Underline */}
                    <div className="w-8 h-0.5 bg-gradient-to-r from-[#DA2128] to-[#FF8A65] rounded-full mt-1.5 group-hover:w-14 transition-all duration-300" />
                  </div>
                </div>

                {/* Point-wise Bullet List */}
                <ul className="space-y-2 mb-4 pl-0.5">
                  {c.points.map((pt, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-[12px] text-[#5a5a6a] leading-relaxed">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#DB6400] mt-1.5 shrink-0 shadow-2xs shadow-[#DB6400]" />
                      <span>{pt}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Footer CTA */}
              <div className="relative z-10 pt-3 border-t border-[#F5ECE5] flex items-center justify-between text-xs font-semibold text-[#DA2128]">
                <span>Explore</span>
                <FiArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </div>
            </a>
          ))}
        </div>
      </div>

    </section>
  );
}